import { Directive, Input, AfterViewInit, OnDestroy } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[addClosedDateTooltip]'
})
export class AddClosedDateTooltipDirective implements AfterViewInit, OnDestroy {
  @Input() picker!: MatDatepicker<any>;
  @Input() disabledDates: Set<string> = new Set();
  @Input() reasonMap: any = {};
  @Input() isNormalBtnColor: any = {};

  private sub!: Subscription;

  ngAfterViewInit() {
    this.sub = this.picker.openedStream.subscribe(() => {
      const checkInterval = setInterval(() => {
        const cells = document.querySelectorAll('.mat-calendar-body-cell');
        if (cells.length > 0) {
          clearInterval(checkInterval);
          this.applyTooltips();
          this.observeCalendar();
        }
      }, 30);
    });
  }

  private observeCalendar() {
    const calendarRoot = document.querySelector('mat-calendar');

    if (!calendarRoot) return;

    const observer = new MutationObserver(() => {
      const monthView = document.querySelector('mat-month-view');
      if (monthView) {
        setTimeout(() => this.applyTooltips(), 10);
      }
    });

    observer.observe(calendarRoot, {
      childList: true,
      subtree: true
    });
  }

  private applyTooltips() {
    const cells = document.querySelectorAll('.mat-calendar-body-cell');
    const header = document.querySelector('.mat-calendar-period-button');
    if (!header) return;

    const headerText = header.textContent!.trim();
    const parts = headerText.split(' ');

    let monthName = '';
    let yearString = '';

    if (parts.length === 3) {
      monthName = parts[1];
      yearString = parts[2];
    } else if (parts.length === 2) {
      monthName = parts[0];
      yearString = parts[1];
    }

    const year = parseInt(yearString, 10);
    const month = this.convertMonthName(monthName);

    if (month === -1) return;

    // 2. Process each day cell
    cells.forEach((cell: any) => {
      const dayDiv = cell.querySelector('.mat-calendar-body-cell-content');
      if (!dayDiv) return;

      const day = parseInt(dayDiv.textContent.trim(), 10);
      if (isNaN(day)) return;

      const date = new Date(year, month, day);
      const iso = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

      if (this.disabledDates.has(iso)) {
        const reason = this.reasonMap[iso] || 'Closed';
        console.log(iso, this.isNormalBtnColor[iso]);
        if (!this.isNormalBtnColor[iso]) {
          dayDiv.classList.add('closed-date');
        } else {
          dayDiv.classList.add('normal-closed-date');
        }
        dayDiv.setAttribute('data-tooltip', reason);
      }
    });
  }

  private convertMonthName(name: string): number {
    name = name.toLowerCase();

    const months = [
      ['january', 'jan', 'januar', 'janvier', 'enero', 'ene', 'gennaio', 'gen', 'januari'],
      ['february', 'feb', 'februar', 'février', 'fevrier', 'febrero', 'feb', 'febbraio', 'febb', 'februari'],
      ['march', 'mar', 'märz', 'maerz', 'mars', 'marzo', 'mrt', 'marzo', 'marz'],
      ['april', 'apr', 'avril', 'abril', 'aprile', 'april'],
      ['may', 'mai', 'mayo', 'maggio', 'mei'],
      ['june', 'jun', 'juni', 'juin', 'junio', 'giugno', 'juni'],
      ['july', 'jul', 'juli', 'juillet', 'julio', 'luglio', 'juli'],
      ['august', 'aug', 'august', 'août', 'agosto', 'ago', 'augustus'],
      ['september', 'sep', 'september', 'septembre', 'septiembre', 'setiembre', 'settembre', 'sep', 'september'],
      ['october', 'oct', 'oktober', 'octobre', 'octubre', 'ottobre', 'okt', 'oktober'],
      ['november', 'nov', 'novembre', 'noviembre', 'novembre', 'november'],
      ['december', 'dec', 'dezember', 'décembre', 'dicembre', 'diciembre', 'december', 'dez']
    ];

    for (let i = 0; i < months.length; i++) {
      if (months[i].some(m => name.startsWith(m))) {
        return i;
      }
    }

    return -1;
  }

  ngOnDestroy() {
    if (this.sub) this.sub.unsubscribe();
  }
}
